import { ChargeContactApi } from "../../../../Shared/Constants/api";
import axiosInstance from "../../../../Shared/Utils/axiosInstance";

export const deleteChargeContactApi = async (id) => {
  try {
    let response = await axiosInstance.delete(`${ChargeContactApi}/${id}`);

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
